import { isStringNotEmpty } from '../../utils/GlobalFunctions'
import { APIMapper, ApplicationUserResponse, JSONResponse } from '../Types/Types'
import { ReportingAccessLevels } from '../../constants/Permissions'

export const accountForDifferentReportingAccessLevelNames: APIMapper<ApplicationUserResponse> = (
    user: JSONResponse<ApplicationUserResponse>
): JSONResponse<ApplicationUserResponse> => {
    if (isStringNotEmpty(user?.Data?.Scope?.ReportingAccess)) {
        switch (user.Data.Scope.ReportingAccess) {
            case ReportingAccessLevels.CXA_STANDARD:
                user.Data.Scope.ReportingAccess = ReportingAccessLevels.ESSENTIALS
                break
            case ReportingAccessLevels.CXA_ADVANCED_HISTORICAL:
                user.Data.Scope.ReportingAccess = ReportingAccessLevels.ENTERPRISE
                break
            case ReportingAccessLevels.CXA_PREMIUM:
                user.Data.Scope.ReportingAccess = ReportingAccessLevels.CALL_CENTRE_AGENT
                break
            case ReportingAccessLevels.CXA_ADVANCED:
                user.Data.Scope.ReportingAccess = ReportingAccessLevels.CALL_CENTRE_SUPERVISOR
                break
            default:
                break
        }
    }

    return user
}
